module.exports = __webpack_public_path__ + "static/media/calendar-outline.d61033f6.svg";